import { createStore } from 'vuex';
import axios from 'axios';
import auth from './auth';
import clients from './clients';
import agreements from './agreements';
import calendar from './calendar';
import quotations from './quotations';
import contractors from './contractors';
import currentUser from './currentUser';
import contacts from './contacts';
import city from './city';
import team from './team';
import legalPerson from './legalPerson';
import services from './services';
import carType from './carType';
import chat from './chat';
import notifications from './notifications';
import template from './template';
import lists from './lists';
import leads from './leads';
import files from './files';
import tasks from './tasks';

const store = createStore({
  state() {
    return {
      lang: localStorage.getItem('lang') || 'ru',
      langText: {},
      initialized: false,
      appName: '',
      appTitle: '',
      appShortName: '',
    };
  },
  actions: {
    async initializeApp({ commit, state, dispatch }) {
      if (!state.initialized) {
        state.initialized = true;

        let crmApiKey = '';
        let crmUrl = '';

        try {
          const cfgResp = await fetch('/pwa-api/config');
          if (cfgResp.ok) {
            const cfg = await cfgResp.json();
            crmApiKey = cfg.api || '';
            crmUrl = cfg.url || cfg.crmUrl || '';
            if (cfg.UniqueID) state.UniqueID = cfg.UniqueID;
            if (cfg.currencyName) state.currencyName = cfg.currencyName;
            if (cfg.services_tied_containers !== undefined) state.services_tied_containers = cfg.services_tied_containers;
            if (cfg.name !== undefined) state.appName = cfg.name;
            if (cfg.title !== undefined) state.appTitle = cfg.title;
            if (cfg.short_name !== undefined) state.appShortName = cfg.short_name;
          }
        } catch (_) {}

        state.crmUrl = crmUrl;
        state.apiKey = crmApiKey;
        axios.defaults.headers.common['Auth-Key'] = crmApiKey;
         axios.defaults.baseURL = '/pwa-api';
         axios.defaults.headers.common['Content-Type'] = 'application/json';

        const token = localStorage.getItem('token');
         if (token) {
           axios.defaults.headers.common['user-auth-key'] = token;
         } else {
           delete axios.defaults.headers.common['user-auth-key'];
         }

        const langRes = await axios.get(`/tech/get_translations/${localStorage.getItem('lang') || 'ru'}.json`);
        state.langText = langRes.data;

        if (localStorage.getItem('token')) {
          await dispatch('getCurrentUser');
        }
      }
    },

    async getLang({ commit }, lang) {
      var result;
      try {
        return await axios
          .get('/tech/get_translations/' + lang + '.json', {
          })
          .then(response => (result = response))
          .catch(error => console.log(error));
      } catch (e) {
        console.log(e);
        throw e;
      }
    },
  },
  modules: {
    auth,
    agreements,
    clients,
    quotations,
    calendar,
    contractors,
    currentUser,
    contacts,
    city,
    team,
    legalPerson,
    carType,
    services,
    chat,
    notifications,
    template,
    lists,
    leads,
    files,
    tasks
  },
});

export default store;
